import "./App.css";
import SpaceMakerSideNav from "./components/SpaceMakerSideNav";
import HeaderBar from "./components/HeaderBar";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Workorders from "./pages/workorders";
import Artifacts from "./pages/artifacts";
import FloorMap from "./pages/floormap"; //comment
import Quote from "./pages/quote";
import Invoice from "./pages/invoice";
import React from "react";

function App() {
  return (
    <Router>
      <HeaderBar />
      <SpaceMakerSideNav />
      <div
        id="snackbar"
        style={{
          position: "absolute",
          zIndex: "99",
          marginTop: "10%",
          left: "20%",
        }}
      >
        <i
          style={{ color: "#ed6c02" }}
          class="fa-solid fa-triangle-exclamation"
        ></i>{" "}
        Maximum window size allowed is 3*2 in ft.
      </div>
      <div
        id="snackbarSmall"
        style={{
          position: "absolute",
          zIndex: "99",
          marginTop: "10%",
          left: "20%",
        }}
      >
        <i
          style={{ color: "#ed6c02" }}
          class="fa-solid fa-triangle-exclamation"
        ></i>{" "}
        Window size is too small, it obstructs the viewing experience.
      </div>
      <Routes>
        <Route path="/" element={<Navigate to="/workorders" />} />
        <Route path="*" element={<Navigate to="/workorders" />} />
        {/* default redirect to Workorders page */}
        <Route path="/workorders" element={<Workorders />} />
        {/* <Route path="/quote" element={<Quote />} /> */}
        <Route path="/artifacts" element={<Artifacts />} />
        <Route path="/floormap" element={<FloorMap />} />
        <Route path="/invoice" element={<Invoice />} />
      </Routes>
    </Router>
  );
}

export default App;
